$(document).ready(function () {
  //$(".index .display_none").load("/pages/phone-cases");
  //   console.log("fjdfghjf");
  var brandValue;
  var modalValue;
  var hrefModel;
  var brand = [];
  var model = [];
  $("#Laptop .category-main-container .sub_cat_main_container").each(
    function () {
      brandValue = $(this).find("h5 span").text();
      brandValue = brandValue.replace(/ /g, "-");
      $(this)
        .find(".sub_cat_main .sub_cat")
        .each(function () {
          modalValue = $(this).find("a").text();
          //modalValue = modalValue.replace(/ /g, "-");
          hrefModel = $(this).find("a").attr("href");
          model.push({
            brandName: brandValue,
            modelName: modalValue,
            hrefName: hrefModel,
          });
        });
      brand.push({
        brandName: brandValue,
      });

      localStorage.setItem("brands", JSON.stringify(brand));
      localStorage.setItem("models", JSON.stringify(model));
    }
  );
  var availVarOptFirst;
  brand.forEach(function (element) {
    availVarOptFirst = element.brandName.trim();
    $(".custom_category_container .brand-selection").append(
      "<option value=" + availVarOptFirst + ">" + availVarOptFirst + "</option>"
    );
  });
  var availFirst;
  var availSecond;
  var availThird;
  $(".brand-selection").change(function () {
    // $('.dropdown-section .modal-selection').html('<option value="default">Select model.</option>');
    $(".custom_category_container .modal-selection").html(
      '<option value="default">Select model</option>'
    );
    var value = $(this).val();
    //console.log(value);
    model.forEach(function (element) {
      availFirst = element.brandName.trim();
      availSecond = element.modelName.trim();
      availThird = element.hrefName.trim();

      if (value == availFirst) {
        $(".custom_category_container .modal-selection").append(
          "<option value=" +
            availFirst +
            " data-href=" +
            availThird +
            ">" +
            availSecond +
            "</option>"
        );
      }
    });
  });

  /***************************************/
  /*
  var availVarOptFirstLocal;
  var brandsLocal = [];
  brandsLocal = localStorage.getItem('brands');
  brandsLocal = JSON.parse(brandsLocal);
//   console.log(brandsLocal);
  brandsLocal.forEach(function(element) {
//     console.log("inner calling...");
    availVarOptFirstLocal = element.brandName.trim();
//     console.log(availVarOptFirstLocal);
    $('.dropdown-section .brand-selection').append("<option value="+availVarOptFirstLocal+">"+availVarOptFirstLocal+"</option>");
  });


  var modelLocal = [];
  modelLocal = localStorage.getItem('models');
  modelLocal = JSON.parse(modelLocal);
 
  var availFirst;
  var availSecond;
  var availThird;
  $('.dropdown-section .brand-selection').change(function(){
    $('.dropdown-section .modal-selection').html('<option value="default">Select model</option>');
    $('.modal-selection option[value=default]').prop('selected','true');
    var value = $(this).val();
    modelLocal.forEach(function(element) {
      availFirst = element.brandName.trim();
      availSecond = element.modelName.trim();
      availThird = element.hrefName.trim();
      if(value == availFirst){
        	$('.dropdown-section .modal-selection').append("<option value="+availFirst+" data-href="+availThird+">"+availSecond+"</option>");
      }
    });
  });
  */

  var modalVal;
  $(".has-dropdown .button").text("View All");
  var mainHref = $(".custom_category_container .has-dropdown .button").attr(
    "href"
  );
  var mainPageHref = $(".collection_title").attr("href");
  $(".brand-selection").change(function () {
    var value = $(this).val();
    $(".has-dropdown .button").text("View All");
    $(".custom_category_container .has-dropdown .button").attr(
      "href",
      mainHref
    );
    $(".has-dropdown.featured-link--half .button").attr("href", mainPageHref);
    $(".modal-selection option:first").prop("selected", "true");
    $(".modal-selection option[value=default]").css("dispaly", "block");

    $(".modal-selection option").each(function () {
      modalVal = $(this).val();
      $(this).css("display", "block");
      if (value == modalVal) {
        $(this).css("display", "block");
      } else {
        $(this).css("display", "none");
      }
    });

    $(".modal-selection").change(function () {
      var value2 = $(this).val();
      var valueHref = $(this).find("option:selected").data("href");
      if (value != "" && value2 != "") {
        $(".has-dropdown .button").text("Shop Now");
        $(".has-dropdown .button").attr("href", valueHref);
      }
    });
  });
});
